import { Stack, Flex, Modal, ModalBody, ModalContent, ModalCloseButton } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { FsmColors } from 'chakra-ui/fsmTheme';

const CTABox = ({ children, useModal = false, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleExitIntent = (e) => {
    // Check if mouse exits viewport
    if (e.clientY <= 0 || e.clientX <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight) {
      setIsOpen(true);
      // Only show exit modal once per session
      const exitModalShown = window.sessionStorage.getItem('exitModalShown') === 'true';
      if (!exitModalShown) {
        setTimeout(() => setIsOpen(true), 1000);
        window.sessionStorage.setItem('exitModalShown', 'true');
      }
    }
  };

  useEffect(() => {
    window.addEventListener('mouseout', handleExitIntent);
    return () => window.removeEventListener('mouseout', handleExitIntent);
  }, []);

  return (
    <Flex bg={FsmColors.navy} color="white" {...rest}>
      <Stack w="100%" p={{ base: 10, md: 20 }} spacing={8}>
        {children}
      </Stack>
      {useModal ? (
        <Modal
          size="xl"
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
          isCentered
        >
          <ModalContent minWidth="900px">
            <ModalCloseButton color="white" />
            <ModalBody bg={FsmColors.navy} border="none" color="white">
              <Stack spacing={10} px={5} py={10}>
                {children}
              </Stack>
            </ModalBody>
          </ModalContent>
        </Modal>
      ) : null}
    </Flex>
  );
};

export default CTABox;
